import { AWSAppSyncRealTimeProvider } from '@aws-amplify/pubsub';
import Observable from 'zen-observable-ts';

/**
 * SEE-1730: GraphQL subscriptions on the CDK AppSync API.
 *
 * API.graphql only reaches the Amplify endpoint, so this points Amplify's own realtime provider at
 * REACT_APP_CDK_APPSYNC_ENDPOINT. It signs with the Cognito access token, whose cognito:groups the
 * server checks against the requested company. One provider, so CDK subscriptions share a socket.
 */
const provider = new AWSAppSyncRealTimeProvider();

export type CdkSubscriptionEvent<T> = { data?: T };

export const cdkSubscribe = <T>(query: string, variables: Record<string, unknown>) =>
  provider.subscribe('', {
    appSyncGraphqlEndpoint: process.env.REACT_APP_CDK_APPSYNC_ENDPOINT,
    authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    query,
    variables,
  }) as Observable<CdkSubscriptionEvent<T>>;

/**
 * Provider errors arrive as { errors: [{ message }] }. A refusal at subscribe time reads
 * 'Connection failed: {"errors":[{"errorType":"Unauthorized",...}]}'; a dropped socket reads
 * 'Connection closed' or 'Timeout disconnect'.
 */
type SubscriptionError = { errors?: { message?: string }[] } | undefined;

export const subscriptionErrorMessages = (error: SubscriptionError): string[] =>
  (error?.errors ?? []).map((item) => item?.message ?? '');

export const isUnauthorizedSubscriptionError = (error: SubscriptionError): boolean =>
  subscriptionErrorMessages(error).some((message) => /"errorType":\s*"Unauthorized"/.test(message));
